import { where, orderBy, limit, startAfter } from "firebase/firestore";

export const MAX_LOCAL_AUTHORITIES_LIMIT = 1000;

/**
 * Build Firestore query constraints based on filters.
 * @param {Object} filters
 * @param {DocumentSnapshot|null} lastDoc
 */
export function buildQueryConstraints(filters, lastDoc = null) {
  const constraints = buildCountQueryConstraints(filters);

  constraints.push(limit(MAX_LOCAL_AUTHORITIES_LIMIT));

  if (lastDoc) {
    constraints.push(startAfter(lastDoc));
  }

  return constraints;
}

/**
 * Build Firestore query constraints based on filters.
 * @param {Object} filters
 * @param {DocumentSnapshot|null} lastDoc
 */
export function buildCountQueryConstraints(filters) {
  const constraints = [];

  if (filters?.isActive != null) {
    constraints.push(where("isActive", "==", filters.isActive));
  }

  if (filters?.region) {
    constraints.push(where("region", "==", filters.region));
  }

  constraints.push(orderBy("name", "asc"));

  return constraints;
}

/**
 * Client-side filtering for items retrieved from database (e.g. search).
 */
export function filterLocalAuthoritiesClientSide({ localAuthorities, search = "" }) {
  const term = (search || "").toLowerCase();

  if (!term || localAuthorities.length === 0) {
    return localAuthorities;
  }

  return localAuthorities.filter((localAuthority) => {
    const matches = [];

    if (term) {
      const idMatch = localAuthority.id && localAuthority.id.toLowerCase().includes(term);
      const nameMatch = localAuthority.name && localAuthority.name.toLowerCase().includes(term);

      matches.push(idMatch || nameMatch);
    }

    return matches.every(Boolean);
  });
}
